"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionify = exports.isRequestLoading = exports.buildActionsFor = exports.reducer = exports.REQUEST_FAILURE = exports.REQUEST_SUCCESS = exports.REQUEST_STARTED = void 0;
exports.createRequestLoadingSelector = createRequestLoadingSelector;
var reselect_1 = require("reselect");
var react_redux_1 = require("react-redux");
var shallowequal_1 = __importDefault(require("shallowequal"));
var reducer_1 = __importDefault(require("./reducer"));
exports.reducer = reducer_1.default;
var actions_1 = require("./actions");
Object.defineProperty(exports, "REQUEST_STARTED", { enumerable: true, get: function () { return actions_1.REQUEST_STARTED; } });
Object.defineProperty(exports, "REQUEST_SUCCESS", { enumerable: true, get: function () { return actions_1.REQUEST_SUCCESS; } });
Object.defineProperty(exports, "REQUEST_FAILURE", { enumerable: true, get: function () { return actions_1.REQUEST_FAILURE; } });
var buildActionsFor = function (methodName) { return ({
    KEY: methodName,
    REQUEST: "".concat(methodName, " Request"),
    SUCCESS: "".concat(methodName, " Success"),
    FAILURE: "".concat(methodName, " Failure")
}); };
exports.buildActionsFor = buildActionsFor;
function createRequestLoadingSelector(actions, requestCompare) {
    return (0, reselect_1.createSelector)(function (state) { return state.actionify.requests; }, function (state, params) { return params; }, function (requests, params) {
        return requests.some(function (request) {
            return request.identifier === actions.KEY &&
                request.status === 'STARTED' &&
                (!requestCompare || requestCompare(request.params, params));
        });
    });
}
var isRequestLoading = function (state, actions, condition) {
    if (condition === void 0) { condition = function () { return true; }; }
    return state.actionify.requests.some(function (request) {
        return request.identifier === actions.KEY &&
            request.status === 'STARTED' &&
            condition(request.params);
    });
};
exports.isRequestLoading = isRequestLoading;
var promiseMap = new Map();
var getParams = function (params) {
    return typeof params === 'function' ? params() : params;
};
var actionify = function (serviceFn, identifier, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.once, once = _c === void 0 ? false : _c, _d = _b.requestCompare, requestCompare = _d === void 0 ? shallowequal_1.default : _d, _e = _b.successProps, successProps = _e === void 0 ? function () { return ({}); } : _e;
    return function (params) {
        return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
            var state, alreadyCalledRequest, symbol, resultPromise, result_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!serviceFn) {
                            throw new Error('Missing mandatory service function');
                        }
                        if (!identifier) {
                            throw new Error('Missing mandatory identifier');
                        }
                        if (once) {
                            state = getState();
                            alreadyCalledRequest = state.actionify.requests.find(function (request) {
                                return request.identifier === identifier.KEY &&
                                    request.status !== 'FAILED' &&
                                    requestCompare(request.params, getParams(params));
                            });
                            if (alreadyCalledRequest) {
                                return [2 /*return*/, promiseMap.get(alreadyCalledRequest.symbol)];
                            }
                        }
                        symbol = Symbol(identifier.KEY);
                        (0, react_redux_1.batch)(function () {
                            dispatch({ type: identifier.REQUEST, params: getParams(params), symbol: symbol });
                            dispatch({
                                type: actions_1.REQUEST_STARTED,
                                identifier: identifier.KEY,
                                params: getParams(params),
                                symbol: symbol
                            });
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        resultPromise = serviceFn(getParams(params));
                        promiseMap.set(symbol, resultPromise);
                        return [4 /*yield*/, resultPromise];
                    case 2:
                        result_1 = _a.sent();
                        promiseMap.delete(symbol);
                        (0, react_redux_1.batch)(function () {
                            dispatch(__assign({ type: identifier.SUCCESS, params: getParams(params), symbol: symbol, result: result_1 }, successProps(getParams(params), result_1)));
                            dispatch({
                                type: actions_1.REQUEST_SUCCESS,
                                identifier: identifier.KEY,
                                params: getParams(params),
                                symbol: symbol
                            });
                        });
                        return [2 /*return*/, result_1];
                    case 3:
                        error_1 = _a.sent();
                        promiseMap.delete(symbol);
                        (0, react_redux_1.batch)(function () {
                            dispatch({
                                type: identifier.FAILURE,
                                params: getParams(params),
                                symbol: symbol,
                                error: {
                                    message: error_1.message,
                                    requestId: error_1.requestId
                                }
                            });
                            dispatch({
                                type: actions_1.REQUEST_FAILURE,
                                identifier: identifier.KEY,
                                params: getParams(params),
                                symbol: symbol
                            });
                        });
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
};
exports.actionify = actionify;
exports.default = exports.actionify;
